





































































































































































import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
import * as a from "@/store/modules/NotificationsModule/actions";
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import * as am from "@/store/modules/AlertModule/mutations";

import { InvertMarkedAsReadCommand, InvertMarkedAsReadReqData } from "@/model/communication/notification/InvertMarkedAsReadCommand";
import { MarkAllAsReadCommand, MarkAllAsReadReqData } from "@/model/communication/notification/MarkAllAsReadCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { notificationsDataTableItemsPerPage } from "@/utility/Constants";
import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { DownloadNotificationsCommand } from "@/model/communication/notification/DownloadNotificationsCommand";
import { GetNotificationsReqData } from "@/model/communication/notification/GetNotificationsReqData";
import { RootState } from "@/store";

export default {
    data() {
        return {
            selected: [],
            periodSelected: "last15",
            notificationsDataTableItemsPerPage,
            downloadLoading: false,
            options: {},
            filter: {
                StartDate: null,
                EndDate: null,
                NotificationTypeListFilter: ["Update"],
                ResultCode: "",
                Device: "",
            },
            headers: [
                { text: this.$t("common.timestamp"), value: "timestamp" },
                { text: this.$t("common.device"), value: "installationName" },
                {
                    text: this.$t("common.file_name"),
                    value: "filename",
                    sortable: false,
                    width: "30%",
                },
                {
                    text: this.$t("notifications.result_code.lbl"),
                    value: "resultCode",
                    align: "center",
                    width: "100px",
                },
                {
                    text: this.$t("notifications.marked_as_read"),
                    value: "isRead",
                    align: "center",
                    sortable: false,
                },
            ],
            dataTableLoading: false,
        };
    },
    computed: {
        ...mapState({
            notifications: (state: RootState) => state.notifications.updateNotifications,
            totalNotifications: (state: RootState) => state.notifications.updateNotifications_length,
            distinctDevices: (state: RootState) => state.notifications.updateDistinctDevices,
            totalNotRead: (state: RootState) => state.notifications.notReadList.filter((n) => n.notificationType == "Update")[0].notRead,
        }),

        subtitlePart1: function () {
            if (this.filter.MarkedAsRead == "true") return ": " + this.$t("notifications.all") + " |";
            else return ": " + this.$t("notifications.unread") + " |";
        },

        subtitlePart2: function () {
            if (this.periodSelected == "last15") return ": " + this.$t("notifications.last15");
            else if (this.periodSelected == "last30") return ": " + this.$t("notifications.last30");
            else return ": " + this.$t("notifications.all");
        },

        allSameMAR: function () {
            let result = false;
            if (this.selected.length > 0) {
                let MAR = this.selected[0].isRead;
                result = true;
                this.selected.forEach((n) => {
                    if (n.isRead != MAR) result = false;
                });
            }
            return result;
        },
    },
    methods: {
        ...mapMutations([am.ADD_ALERT]),
        ...mapActions([a.FETCH_NOTIFICATIONS, a.TOTAL_NOT_READ_NOTIFICATIONS]),

        localeTimeFromUtc: function (UtcDate) {
            return moment.utc(UtcDate).format();
        },

        async InvertMarkedAsReadAttribute(item) {
            let reqData = new InvertMarkedAsReadReqData();
            reqData.notificationIds = [item.id];
            let response: ApiGenericResponse = await new InvertMarkedAsReadCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.fetchNotifications();
            }
        },

        async MarkAllRead() {
            let reqData = new MarkAllAsReadReqData();
            reqData.notificationType = NotificationTypesEnum.Update;
            let response: ApiGenericResponse = await new MarkAllAsReadCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.fetchNotifications();
            }
            this.selected = [];
        },

        async MultipleInvertMarkedAsReadAttribute() {
            let notificationIds = [];
            this.selected.forEach((n) => notificationIds.push(n.id));
            let reqData = new InvertMarkedAsReadReqData();
            reqData.notificationIds = notificationIds;
            let response: ApiGenericResponse = await new InvertMarkedAsReadCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.fetchNotifications();
            }
            this.selected = [];
        },

        async fetchNotifications() {
            this.dataTableLoading = true;
            this.filter.StartDate = new Date();
            let endDate = new Date();
            if (this.periodSelected == "last15") this.filter.StartDate.setDate(endDate.getDate() - 15);
            if (this.periodSelected == "last30") this.filter.StartDate.setDate(endDate.getDate() - 30);
            if (this.periodSelected == "all") this.filter.StartDate = null;
            await this[a.TOTAL_NOT_READ_NOTIFICATIONS]();
            await this[a.FETCH_NOTIFICATIONS]({
                filter: this.filter,
                options: this.options,
            });
            this.dataTableLoading = false;
        },

        async exportAs(type) {
            this.downloadLoading = true;

            try {
                let reqData = new GetNotificationsReqData();
                reqData.startDate = this.filter.StartDate;
                reqData.endDate = this.filter.EndDate;
                reqData.notificationTypeListFilter = this.filter.NotificationTypeListFilter;
                reqData.markedAsRead = this.filter.MarkedAsRead;
                reqData.resultCode = this.filter.ResultCode;
                reqData.device = this.filter.Device;
                reqData.offset = (this.options.page - 1) * this.options.itemsPerPage;
                reqData.queryLimit = this.options.itemsPerPage;
                reqData.orderBy = this.options.sortBy;
                reqData.orderByDescending = this.options.sortDesc;
                const res = await new DownloadNotificationsCommand(type, reqData).execute();
                let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                document.body.appendChild(fileLink);
                fileLink.click();
            } catch (err) {
                this[am.ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("notifications.error_csv_downloading"), null));
            }
            this.downloadLoading = false;
        },

        radioChange() {
            this.selected = [];
            this.fetchNotifications();
        },
    },
    mounted() {
        this.fetchNotifications();
    },
};
